import { EJoinOtaStep } from '../../types/joinOtaIndividual/step';
import { ELandingType } from '../../types/landingType';

interface IGetJoinOtaStepsArgs {
  landingType?: ELandingType;
}

export function getJoinOtaSteps({ landingType }: IGetJoinOtaStepsArgs): EJoinOtaStep[] {
  if (landingType === ELandingType.JoinOtaCian) {
    return [EJoinOtaStep.UserData, EJoinOtaStep.Insurance, EJoinOtaStep.Success].filter(Boolean) as EJoinOtaStep[];
  }

  return [EJoinOtaStep.Unexpected];
}
